module.exports = __webpack_public_path__ + "img/ico4.e676297f.png";